/**
 * Specifies the available audio modes for media playback.
 *
 * @enum {string}
 * @property {string} NO_AUDIO - Indicates that no audio will be played.
 * @property {string} SELECTABLE_AUDIO - Indicates that audio tracks can be selected during playback.
 */
export enum AudioMode {
    NO_AUDIO = "no_audio",
    SELECTABLE_AUDIO = "selectable"
};

/**
 * Specifies the playback mode for the media player.
 *
 * @enum {string}
 * @property {PlayMode.LOOP} LOOP - Play media in a continuous loop.
 * @property {PlayMode.SINGLE_PLAY} SINGLE_PLAY - Play media once and stop.
 */
export enum PlayMode {
    LOOP = "loop",
    SINGLE_PLAY = "single"
};



/**
 * Options for media playback configuration.
 *
 * @property audioMode - Specifies the audio mode to use during playback.
 * @property playMode - Specifies the playback mode.
 * @property timeCutSeconds - (Optional) Number of seconds to cut from the playback time.
 */
export interface MediaPlayOptions {
    audioMode: AudioMode,
    playMode: PlayMode,
    timeCutSeconds?: number
}



/**
 * Default options for video playback.
 *
 * @remarks
 * This constant provides the default configuration for playing videos,
 * including selectable audio mode, looped play mode, and no time cut.
 *
 * @property {AudioMode} audioMode - Sets the audio mode to selectable audio.
 * @property {PlayMode} playMode - Sets the play mode to loop.
 * @property {number} timeCutSeconds - Indicates no time cut with a value of -1.
 */
export const DefaultVideoPlayOptions: MediaPlayOptions = {
    audioMode: AudioMode.SELECTABLE_AUDIO,
    playMode: PlayMode.LOOP,
    timeCutSeconds: -1
};